var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 447.54 114.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#03234b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.35,0H57.62A29,29,0,0,0,31.07,17.27L.13,91.8a1.62,1.62,0,0,0,1.51,2.25H72.41c5,0,7.22-4.84,3.3-8.71L49.72,61c-13.66-13.39-7.8-44.44,20.57-44.44H208.84a1.64,1.64,0,0,0,1.55-1.09l5.48-13.25a1.59,1.59,0,0,0,.12-.62A1.64,1.64,0,0,0,214.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.73,37.94l-26.61,0a4.3,4.3,0,0,0-4,2.63l-29.81,72a1.58,1.58,0,0,0-.19.75,1.62,1.62,0,0,0,1.63,1.61h9.93a29,29,0,0,0,26.81-17.67l0,0,23.69-57.19a1.73,1.73,0,0,0,.12-.6A1.6,1.6,0,0,0,198.73,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.43,39.55a1.63,1.63,0,0,0-1.64-1.62H69.35c-4.09,0-7.67,5-3.34,9L90.93,70.14s10.09,9.3,7.93,22.61C97,104.47,89,111.64,83.17,114.22h0a.4.4,0,0,0,.18.77H112.4a4.29,4.29,0,0,0,4-2.63L146.3,40.12A1.25,1.25,0,0,0,146.43,39.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.7,91.54a6.45,6.45,0,1,1,0-12.9,6.4,6.4,0,0,1,6.3,6.48,6.29,6.29,0,0,1-6.3,6.42m6.18-11.94a7.46,7.46,0,0,0-6.19-3,8.53,8.53,0,1,0,0,17.06,7.54,7.54,0,0,0,6.19-3v2.66h2.29V77h-2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.62,85.59c0,2.85-.77,3.86-1.64,4.72a4.46,4.46,0,0,1-3.32,1.26A4.62,4.62,0,0,1,303,90.09a6.5,6.5,0,0,1-1.12-4.15V77h-2.29v9a8.19,8.19,0,0,0,1.43,5.23,6.9,6.9,0,0,0,5.61,2.45A5.52,5.52,0,0,0,311.73,91v2.25h2.17V77h-2.29v8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,91.54a6.45,6.45,0,1,1,6.24-6.42c0,2.59-2,6.42-6.24,6.42m6.12-11.88a7.43,7.43,0,0,0-6.13-3.1,8.54,8.54,0,0,0,0,17.07c2,0,4.8-.83,6.13-3.1V91.6c0,4.33-3.06,5.86-5.69,5.86a6.12,6.12,0,0,1-5.9-4l0-.08h-2.4l0,.15c1.62,5.55,6.78,6,8.32,6,.44,0,4.35-.08,6.46-3a9.22,9.22,0,0,0,1.49-5.93V77H331.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.18,76.58a6.28,6.28,0,0,0-5.39,2.94,6.29,6.29,0,0,0-5.4-2.94,5.36,5.36,0,0,0-4.25,2V77h-2.29V93.27h2.29V83.86a6.07,6.07,0,0,1,.72-3.28,4.22,4.22,0,0,1,7.06,0,6.11,6.11,0,0,1,.72,3.29v9.41h2.29V83.86a6.07,6.07,0,0,1,.72-3.28,4.22,4.22,0,0,1,7.06,0,6.11,6.11,0,0,1,.72,3.29v9.41h2.29V83.62c0-5.56-4.11-7-6.54-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.78,83.9a6.19,6.19,0,0,1,12.23,0Zm6.07-7.33a8.62,8.62,0,0,0-8.44,8.56,8.47,8.47,0,0,0,16.47,2.79l.06-.16h-2.42l0,.08a5.93,5.93,0,0,1-5.64,3.7A6.27,6.27,0,0,1,365.76,86h14.59v-.11a8.67,8.67,0,0,0-8.51-9.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.59,76.58a5.91,5.91,0,0,0-4.87,2.29V77h-2.29V93.27h2.29v-9A5.75,5.75,0,0,1,387.18,80a5,5,0,0,1,3.41-1.34A5.06,5.06,0,0,1,394,80a5.92,5.92,0,0,1,1.49,4.31v8.94h2.29V84.32a7.78,7.78,0,0,0-2-5.74,6.77,6.77,0,0,0-5.16-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "405.96 71.32 403.67 71.32 403.67 76.99 400.3 76.99 400.3 79.08 403.67 79.08 403.67 93.27 405.96 93.27 405.96 79.08 409.8 79.08 409.8 76.99 405.96 76.99 405.96 71.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.48,83.89a6.19,6.19,0,0,1,12.23,0Zm6.08-7.33a8.62,8.62,0,0,0-8.44,8.56,8.47,8.47,0,0,0,16.47,2.79l.06-.16h-2.42l0,.08a5.93,5.93,0,0,1-5.63,3.7A6.27,6.27,0,0,1,413.48,86h14.59v-.11a8.67,8.67,0,0,0-8.52-9.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.07,91.55a6.45,6.45,0,1,1,0-12.9,6.4,6.4,0,0,1,6.3,6.48,6.28,6.28,0,0,1-6.3,6.42m6.18-20.22v8.24a7.79,7.79,0,0,0-6.19-3,8.53,8.53,0,1,0,0,17.06,7.7,7.7,0,0,0,6.19-3v2.64h2.29V71.32h-2.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 228.36,
    y: 70.76,
    width: 2.18,
    height: 3.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "220.94 71.33 216.19 71.33 216.19 73.38 218.77 73.38 218.77 91.21 216.01 91.21 216.01 93.26 223.49 93.26 223.49 91.21 220.94 91.21 220.94 71.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.07 76.99 226.31 76.99 226.31 79.05 228.89 79.05 228.89 91.21 226.25 91.21 226.25 93.26 233.65 93.26 233.65 91.21 231.07 91.21 231.07 76.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240,72.37c-1.42,1.27-1.48,2.74-1.54,4.52V77h-2.58v2.11h2.61V91.21h-2.61v2.06h7.42V91.21h-2.64V79.12h2.64V77h-2.64v-.35c0-1.17.05-2.19,1-2.93A3.65,3.65,0,0,1,243.8,73h.11V71h-.13A5.79,5.79,0,0,0,240,72.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.58,84.22a6.18,6.18,0,0,1,5.93-5.2,6.25,6.25,0,0,1,6.28,5.2Zm6-7.23a8.31,8.31,0,1,0,7.7,11.74l.08-.17H260l0,.06a6.13,6.13,0,0,1-11.36-2.54h14.34v-.72A8.29,8.29,0,0,0,254.54,77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.34,93.69a2.82,2.82,0,1,0-2.82-2.82,2.82,2.82,0,0,0,2.82,2.82"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStLogo);
export default __webpack_public_path__ + "static/media/st-logo.01d65641d9828fd6847ef785b4019063.svg";
export { ForwardRef as ReactComponent };